import Learning from './Learning.png';
import Maturity from './Maturity.png';
import Portfolio from './Portfolio.png';
import Progress from './Progress.png';
import Security from './Security.png';
import Silos from './Silos.png';

const benefitsImages = {
  Learning,
  Maturity,
  Portfolio,
  Progress,
  Security,
  Silos

};

export default benefitsImages;
